import { useQuery } from "react-query"
import { getConsultations } from "./consultationsApi"

export const useConsultations = (request: any) => {
  return useQuery(['consultations-list', { ...request }], {
    queryFn: () => (getConsultations(request)),
    keepPreviousData: false
  })
}